<section class="gradient-section">
  <div class="content-wrapper">
    <div class="gradient-text">
      <p>So what are you waiting for? join the train.</p>
      <h2>
        One solution that works <br />
        for everyone
      </h2>
      <p>
        Invitte simplifies event planning by bringing everything concerning
        invitations, ticketing, vendor coordination, and guest management into
        one seamless platform. Whether it's a wedding, concert, or corporate
        event, you can track RSVPs, automate updates, and manage payments with
        ease. The platform matches you with event vendors and provides smart
        tools for budgeting and real-time settlements. Say goodbye to juggling
        multiple apps and hello to an all-in-one, stress-free experience.
        Invitte is designed for elegance, efficiency, and control at every stage
        of your event. It’s not just a tool, it’s your event partner.
      </p>
    </div>

    <div class="gradient-images">
      <img src="/assets/img/Frame 1321314601.svg" alt="img4" />
    </div>
  </div>
</section>
<footer>
  <div
    class="logo pb-5"
    style="display: flex; justify-content: center; align-items: center"
  >
    <img
      src="/assets/img/Logo.svg"
      alt="Logo"
      style="display: block; width: 12%"
    />
  </div>
  <br />

  <p style="text-align: center; font-size: 0.9rem">
    We are designed to empower event hosts to create and manage their events
    effortlessly, ensuring a memorable and <br />
    stress-free experience for both hosts and guests.
  </p>
  <br />

  <div class="links" style="text-align: center">
    <a routerLink="/event/explore">Events</a>
    <a href="mailto:info@invitte.app">Contact</a>
    <a routerLink="/event/feeds">Access an event</a>
    <a routerLink="/legal-documentation/terms-of-service">Terms & conditions</a>
    <a routerLink="/legal-documentation/privacy-policy">Privacy policy</a>
  </div>

  <br />

  <div class="socials pb-3">
    <a href="https://www.facebook.com/profile.php?id=61564336462412"
      ><img src="/assets/img/Facebook (3).svg" alt="Facebook" width="50"
    /></a>
    <a href="https://x.com/joininvitte?s=11&t=k4zgDPydcbb3uvkc6mMpIg"
      ><img src="/assets/img/Twitter (2).svg" alt="Twitter" width="50"
    /></a>
    <a href="https://www.linkedin.com/company/invitte/"
      ><img src="/assets/img/Linkedin (2).svg" alt="LinkedIn" width="50"
    /></a>
  </div>

  <p style="text-align: center; margin-bottom: -20px">
    &copy; {{ currentYear }} Invitte Technologies Limited. All rights reserved
  </p>
</footer>

<!-- <section>
  <div class="table">
    <div class="footer p-5">
      <div class="col-lg-6 ml-4">
        <div class="row logo-desc-contact">
          <div class="col">
            <div class="footer-logo P-3">
              <img src="/assets/img/Logo.png" />
            </div>
          </div>
          <div class="col mr-5">
            <div class="footer-desc">
              We are designed to empower event hosts to create and manage their
              events effortlessly, ensuring a memorable and stress-free
              experience for both hosts and guests.
            </div>
            <br /><br /><br />
            <div class="footer-contact">
              <a
                class="text-light"
                href="mailto:info@invitte.app"
                style="text-decoration: underline; color: white"
                >info@invitte.app</a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 ml-5">
        <div class="row link-social-uparrow">
          <div class="row link-social">
            <div class="footer-links col p-1">
              <ul>
                <li><a href="#">Access an event</a></li>
                <li><a href="#">Explore page</a></li>
                <li><a href="#">Contact</a></li>
                <li>
                  <a routerLink="/legal-documentation/privacy-policy"
                    >Privacy policy</a
                  >
                </li>
                <li>
                  <a routerLink="/legal-documentation/terms-of-service"
                    >Terms & conditions</a
                  >
                </li>
              </ul>
            </div>

            <div class="footer-social col p-1">
              <ul>
                
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/profile.php?id=61564336462412"
                    >Facebook</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://x.com/joininvitte?s=11&t=k4zgDPydcbb3uvkc6mMpIg"
                    >Twitter</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://www.tiktok.com/@joininvitte"
                    >TikTok</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="footer-up-arrow col">
            <img
              src="/assets/img/Up arrow.png"
              alt="Back to top"
              (click)="scrollToTop()"
            />
        
          </div>
        </div>

        <div class="footer-rights">© 2024 Invitte app. All rights reserved</div>
      </div>
    </div>
  </div>
</section> -->
